<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>Discounts</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div class="discounts-modal">
    <ion-toolbar mode="md" color="orange" class="subheader">
      <ion-title>Only one discount can be applied at a time</ion-title>
    </ion-toolbar>
    <ion-list class="discounts">
      <ion-item *ngFor="let item of discounts"
                class="discounts__item">
        <ion-label class="discounts__item__name">
          <h2>
            <strong>{{item.name}}</strong>
          </h2>
        </ion-label>
        <ion-button *ngIf="!selectedDiscountId || selectedDiscountId !== item.id"
                    mode="md"
                    color="dark"
                    [disabled]="selectedDiscountId"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onAddDiscount(item)">ADD</ion-button>
        <ion-button *ngIf="selectedDiscountId && selectedDiscountId === item.id"
                    mode="md"
                    color="danger"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onRemoveDiscount(item)">REMOVE</ion-button>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
